<script>
import toggle from '@utils/design/toggle-info'
import { filtersComputed, infoComputed, infoMethods } from '@state/helpers'

export default {
  props: {
    list: {
      type: Array,
      required: true,
      default: () => [],
    },
  },

  computed: {
    ...filtersComputed,
    ...infoComputed,

    routeRecords: function() {
      return this.list.filter((route) => route.name || route.meta.label)
    },
  },

  methods: {
    ...infoMethods,

    getName(item) {
      return item.meta && item.meta.label ? item.meta.label : item.name || null
    },

    isLast(index) {
      return index === this.list.length - 1
    },

    clickToggle: function(e) {
      toggle(true)
    },

    clickCompact: function(e) {
      this.setCompact({ compact: !this.selectedCompact })
    },
  },
}
</script>

<template>
  <ol class="breadcrumb">
    <li v-for="(routeObject, index) in routeRecords" :key="index" class="breadcrumb-item">
      <span v-if="isLast(index)" class="active text-uppercase font-weight-bold ">
        {{ getName(routeObject) }}
      </span>
      <router-link
        v-else
        :to="routeObject"
        class="active text-uppercase font-weight-bold "
        >{{ getName(routeObject) }}</router-link
      >

      <span
        v-if="deviceFilters.name"
        class="text-uppercase font-weight-bold breadcrumb-info"
      >
        {{ deviceFilters.name }}
      </span>
    </li>
    <li class="breadcrumb-menu">
      <a class="breadcrumb-link" @click="clickCompact"> <i class="icon-grid"></i></a>
    </li>
  </ol>
</template>

<style lang="css">
.breadcrumb {
    min-height: 49px;
        padding: 0.75rem 0.85rem!important;
}
.breadcrumb-item{
    color: #666666!important;
    padding-top: 4px;
}
.breadcrumb-info{
    color: #cccccc!important;
    padding-top: 4px;
}
.breadcrumb-link {
  margin-left: 10px;
  font-size: 1.3rem !important;
  color: #666666!important;
  text-decoration: none;
  cursor: pointer;
}
.breadcrumb-link:hover {
  color: #cccccc;
  text-decoration: none;
}
</style>
